import { render, staticRenderFns } from "./CartaoDeObservacoes.vue?vue&type=template&id=36a75920&scoped=true"
import script from "./CartaoDeObservacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeObservacoes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeObservacoes.vue?vue&type=style&index=0&id=36a75920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a75920",
  null
  
)

export default component.exports